import { FormTemplateSection } from 'data/template/template.types';
import { TabProp } from 'shared/multi-tab/MultiTab';
import * as types from 'data/collectionFunction/collectionFunction.types';

export default function hideInterfaceSection(
  formTemplateSection:FormTemplateSection | undefined,
  isEditing:boolean,
  tabs:TabProp[],
  data: Partial<types.CollectionFunctionFormData>,
): boolean {
  const hasNoInterfacesInViewMode = isEditing === false && tabs?.length === 0;
  return hasNoInterfacesInViewMode || formTemplateSection == null || data.deliveryThru === 'AF_DELIVERY';
}
